import { render, staticRenderFns } from "./HomepageTitle.vue?vue&type=template&id=76065028&"
import script from "./HomepageTitle.vue?vue&type=script&lang=js&"
export * from "./HomepageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports